import React from "react";
import { ShieldCheck, Boxes, LineChart, Headset } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHx3YXJlaG91c2UlMjBsb2dpc3RpY3N8ZW58MHx8fHwxNzg1MjIwMDUxfDA&ixlib=rb-4.1.0&q=85";

const POINTS = [
  { icon: Headset, title: "Never miss a follow-up", text: "Today, overdue and upcoming reminders on one screen." },
  { icon: Boxes, title: "Stock that stays accurate", text: "Barcode stock-in, stock-out and low stock alerts." },
  { icon: LineChart, title: "Know what is converting", text: "Lead funnel and team performance in Admin Analytics." },
];

export const AuthLayout = ({ title, subtitle, children, footer }) => (
  <div className="flex min-h-screen bg-background">
    {/* Brand panel */}
    <div className="relative hidden w-[46%] shrink-0 overflow-hidden lg:block">
      <img src={HERO} alt="Warehouse operations" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0" style={{ background: "linear-gradient(165deg, hsl(26 30% 8% / 0.92), hsl(24 60% 18% / 0.86))" }} />
      <div className="grain relative flex h-full flex-col justify-between p-12">
        <div className="flex items-center gap-3">
          <span className="grid h-10 w-10 place-items-center rounded-lg bg-gradient-warm text-primary-foreground shadow-glow">
            <ShieldCheck className="h-5 w-5" />
          </span>
          <div>
            <p className="font-display text-base font-bold text-primary-foreground">Megatronix Vision</p>
            <p className="text-xs text-primary-foreground/70">Robusto Cases . Drones . Accessories</p>
          </div>
        </div>

        <div className="max-w-md">
          <h2 className="font-display text-4xl font-bold leading-tight text-primary-foreground">
            Run sales, stock and billing<br />from one calm workspace.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-primary-foreground/80">
            A simple business management tool built for the people who use it every day &mdash; not for an IT department.
          </p>
          <div className="mt-10 space-y-5">
            {POINTS.map((p) => (
              <div key={p.title} className="flex items-start gap-3.5">
                <span className="mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-lg border border-primary-foreground/20 bg-primary-foreground/10 text-primary-foreground">
                  <p.icon className="h-4 w-4" />
                </span>
                <div>
                  <p className="text-sm font-semibold text-primary-foreground">{p.title}</p>
                  <p className="text-sm text-primary-foreground/70">{p.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <p className="text-xs text-primary-foreground/60">
          &copy; {new Date().getFullYear()} Megatronix Vision. Role based access . Audit logged . Secure by design.
        </p>
      </div>
    </div>

    {/* Form panel */}
    <div className="flex flex-1 items-center justify-center bg-gradient-panel px-5 py-10 sm:px-10">
      <div className="w-full max-w-[26rem] animate-fade-up">
        <div className="mb-8 flex items-center gap-3 lg:hidden">
          <span className="grid h-10 w-10 place-items-center rounded-lg bg-gradient-warm text-primary-foreground">
            <ShieldCheck className="h-5 w-5" />
          </span>
          <div>
            <p className="font-display text-base font-bold">Megatronix Vision</p>
            <p className="text-xs text-muted-foreground">ERP &amp; CRM</p>
          </div>
        </div>

        <h1 className="font-display text-3xl font-bold tracking-tight text-foreground">{title}</h1>
        {subtitle && <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>}
        <div className="mt-8">{children}</div>
        {footer && <div className="mt-8 text-center text-sm text-muted-foreground">{footer}</div>}
      </div>
    </div>
  </div>
);
